import { useRouter } from 'next/router';
import React, { FC, ReactNode, useEffect, useState } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth';
import { BiWindows } from 'react-icons/bi';
import NavBar from './NavBar';
import Sidebar from './Sidebar';
import { auth } from '../firebase/firebase';

interface AuthContainerProps {
  children?: ReactNode;
}

const AuthContainer: FC<AuthContainerProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [authenticated] = useAuthState(auth);
  const router = useRouter();
  const { prev }: any = router.query;

  useEffect(() => {
    if (!authenticated) return;

    // redirect to the previous URL after login/signup based on 'prev' param
    (prev && prev !== '/404') ? router.push(prev) : router.push('/');

    // if user navigates through URL, we expect no 'prev' param in URL,
    // so we just push the user back to the previous URL
    (window.length > 2) ? router.back() : router.push('/');

  }, [authenticated])

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <div className="auth-container">
      <NavBar handleDrawerToggle={handleDrawerToggle} />
      <Sidebar open={open} handleDrawerToggle={handleDrawerToggle}/>

      <div className="form-container">
        {children}
      </div>
    </div>
  )
}

export default AuthContainer
